module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/store_images/4_caaf333b03af13326cd046a0f5987443.png";